import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { REGION_CONFIG } from '../../config/region';

// Import all mascot images
import AnimaLeeImage from '../../assets/Croppedmascotts/AnimaLee f_or _fiter_family_friendly_TRUE.png';
import BakeLeeImage from '../../assets/Croppedmascotts/BakeLee.png';
import BeachClubLeeImage from '../../assets/Croppedmascotts/BeachCLubLee_HonestLee_Reelaxed.jpg';
import BeeneeLeeImage from '../../assets/Croppedmascotts/BeeneeLee _honestLee good Beens.png';
import BiryaneeLeeImage from '../../assets/Croppedmascotts/BiryaneeLee.png';
import BreakLeeImage from '../../assets/Croppedmascotts/BreakLee _for_filter_serves_Breakfast_True.png';
import CameLeeImage from '../../assets/Croppedmascotts/CameLee_for_CamelMilk_mobile_vendors.png';
import CardLeeImage from '../../assets/Croppedmascotts/CardLee_a_filter_for_all_places_accepting_CardPayments.png';
import ChaiLeeImage from '../../assets/Croppedmascotts/ChaiLee_street_vendors.png';
import ChawarmeeLeeImage from '../../assets/Croppedmascotts/ChawarmeeLee.png';
import CLeeNicImage from '../../assets/Croppedmascotts/CLeeNic_HonestLee_getting_Treeted _link_with_venue_category_clinic .png';
import CocktaiLeeImage from '../../assets/Croppedmascotts/CocktaiLee_for_venue_type_cocktail_bar.png';
import CoffeeLeeImage from '../../assets/Croppedmascotts/CoffeeLee_HonestLee_good_Beens _iuse_this_for_the_street_vendor_coffee_carts .png';
import CryptLeeImage from '../../assets/Croppedmascotts/CryptLee.png';
import DaiLeeImage from '../../assets/Croppedmascotts/DaiLee_for_daily_shores_palces_think_we_have_none_yet.png';
import DateLeeImage from '../../assets/Croppedmascotts/DateLee_for_the_mobile_date_shops .png';
import FaciaLeeImage from '../../assets/Croppedmascotts/FaciaLee .png';
import FalafLeeImage from '../../assets/Croppedmascotts/FalafLee_HonestLee_FLuffee_Inside.png';
import FastLeeImage from '../../assets/Croppedmascotts/FastLee_HonestLee_not_so_Healthee.png';
import FestivaLeeImage from '../../assets/Croppedmascotts/FestivaLee.png';
import FineLeeImage from '../../assets/Croppedmascotts/FineLee_Honestlee_Deelicious.png';
import FitLeeImage from '../../assets/Croppedmascotts/FitLee.png';
import FoodCOurtLeeImage from '../../assets/Croppedmascotts/FoodCOurtLee.png';
import Gemini1Image from '../../assets/Croppedmascotts/Gemini_Generated_Image_amwwjramwwjramww.png';
import Gemini2Image from '../../assets/Croppedmascotts/Gemini_Generated_Image_bwb9ksbwb9ksbwb9.png';
import Gemini3Image from '../../assets/Croppedmascotts/Gemini_Generated_Image_d3553id3553id355.png';
import Gemini4Image from '../../assets/Croppedmascotts/Gemini_Generated_Image_d95yvvd95yvvd95y.png';
import GolfLeeImage from '../../assets/Croppedmascotts/GolLee_HonestLee_Swingee.png';
import GymLeeImage from '../../assets/Croppedmascotts/GymLee.png';
import HamamLeeImage from '../../assets/Croppedmascotts/HamamLee_HonestLee_Leelaxing.png';
import HappeeLeeImage from '../../assets/Croppedmascotts/HappeeLee_HonesLee_Happee.png';
import HealtheeLeeImage from '../../assets/Croppedmascotts/HealtheeLee.jpg';
import HennaLeeImage from '../../assets/Croppedmascotts/HennaLee.png';
import IceLeeImage from '../../assets/Croppedmascotts/IceLee_HonestLee_Yummee.png';
import IceLeeStreetImage from '../../assets/Croppedmascotts/IceLee_link_to_street.png';
import KebabLeeImage from '../../assets/Croppedmascotts/KebabLee.png';
import KunafeeLeeImage from '../../assets/Croppedmascotts/KunafeeLee_Honestlee_Sweet.png';
import LaundreeLeeImage from '../../assets/Croppedmascotts/LaundreeLee.jpg';
import LeeFiImage from '../../assets/Croppedmascotts/LeeFi.png';
import LeesPressoImage from '../../assets/Croppedmascotts/LeesPresso_Honestlee_good_Breew.png';
import LuquaineeLeeImage from '../../assets/Croppedmascotts/LuquaineeLee_HonestLee_Sweeet.png';
import ManaqeeLeeImage from '../../assets/Croppedmascotts/ManaqeeLee.png';
import PadLeeImage from '../../assets/Croppedmascotts/PadLee_HonestLee.png';
import PamperLeeImage from '../../assets/Croppedmascotts/PamperLee_HonestLee_ReeLaxed.png';
import ParteeLeeImage from '../../assets/Croppedmascotts/ParteeLee.png';
import PeeLateesImage from '../../assets/Croppedmascotts/PeeLatees.png';
import PlugLeeImage from '../../assets/Croppedmascotts/PlugLee.png';
import QuietLeeImage from '../../assets/Croppedmascotts/QuietLee_HonestLee_Peeceful_Coworking.png';
import SeeFoodLeeImage from '../../assets/Croppedmascotts/SeeFoodLee_HonestlLee-Fishee.png';
import ShishaLeeImage from '../../assets/Croppedmascotts/ShishaLee_for_all_Shisha_places.png';
import ShopLeeImage from '../../assets/Croppedmascotts/ShopLee.png';
import SinghLeeImage from '../../assets/Croppedmascotts/SinghLee_Honestlee_Baad.png';
import SugarLeeImage from '../../assets/Croppedmascotts/SugarLee.png';
import SunsetLeeImage from '../../assets/Croppedmascotts/SunsetLee.png';
import SusheeLeeImage from '../../assets/Croppedmascotts/SusheeLee.png';
import SweatLeeImage from '../../assets/Croppedmascotts/SweatLee_HonestLee_Steemee.png';
import TeeLeeImage from '../../assets/Croppedmascotts/TeeLee_Honestlee_Teelaxing.png';
import TeeVeeLeeImage from '../../assets/Croppedmascotts/TeeVeeLee.png';
import VegeeLeeImage from '../../assets/Croppedmascotts/VegeeLee.jpg';
import YogeeImage from '../../assets/Croppedmascotts/Yogee.jpg';

const getDiscoveryData = (t) => [
  { 
    id: 1, 
    image: AnimaLeeImage, 
    title: "AnimaLee", 
    description: t('discovery.descAnimaLee'), 
    category: "Pet Friendly",
    filterAction: {petPolicy: ['Pets Allowed (outdoor)']  } // ✅ Map to filter
  },
  { 
    id: 2, 
    image: BakeLeeImage, 
    title: "BakeLee", 
    description: t('discovery.descBakeLee'), 
    category: "Bakery",
    filterAction: { venueCategory: ['Cafe'], cuisineTags: ['Pastries'] }
  },
  { 
    id: 3, 
    image: BeachClubLeeImage, 
    title: "Beach Club Lee", 
    description: t('discovery.descBeachClubLee'), 
    category: "Beach Club",
    filterAction: {  venueCategory: ['Beach Club'] }
  },
  { 
    id: 4, 
    image: BeeneeLeeImage, 
    title: "BeeneeLee", 
    description: t('discovery.descBeeneeLee'), 
    category: "Coffee",
    filterAction: { venueCategory: ['Cafe'] }
  },
  { 
    id: 5, 
    image: BiryaneeLeeImage, 
    title: "BiryaneeLee", 
    description: t('discovery.descBiryaneeLee'), 
    category: "Indian Cuisine",
    filterAction: { cuisineTags: ['Indian', 'Biryani'] }
  },
  { 
    id: 6, 
    image: BreakLeeImage, 
    title: "BreakLee", 
    description: t('discovery.descBreakLee'), 
    category: "Breakfast",
    filterAction: { venueSubType: ['Breakfast'] }
  },
  { 
    id: 7, 
    image: CameLeeImage, 
    title: "CameLee", 
    description: t('discovery.descCameLee'), 
    category: "Street Vendors",
    filterAction: { venueCategory: ['Street Vendor'] }
  },
  { 
    id: 8, 
    image: CardLeeImage, 
    title: "CardLee", 
    description: t('discovery.descCardLee'), 
    category: "Card Payment",
    filterAction: { paymentCard: true }
  },
  { 
    id: 9, 
    image: ChaiLeeImage, 
    title: "ChaiLee", 
    description: t('discovery.descChaiLee'), 
    category: "Street Vendors",
    filterAction: { venueCategory: ['Street Vendor'], cuisineTags: ['Tea', 'Chai'] }
  },
  { 
    id: 10, 
    image: ChawarmeeLeeImage, 
    title: "ChawarmeeLee", 
    description: t('discovery.descChawarmeeLee'), 
    category: "Middle Eastern",
    filterAction: { cuisineTags: ['Shawarma', 'Middle Eastern'] }
  },
  { 
    id: 11, 
    image: CLeeNicImage, 
    title: "CLeeNic", 
    description: t('discovery.descCLeeNic'), 
    category: "Healthcare",
    filterAction: { venueCategory: ['Clinic'] }
  },
  { 
    id: 12, 
    image: CocktaiLeeImage, 
    title: "CocktaiLee", 
    description: t('discovery.descCocktaiLee'), 
    category: "Cocktail Bar",
    filterAction: { venueCategory: ['Bar'], venueSubType: ['Cocktail Bar'] }
  },
  { 
    id: 13, 
    image: CoffeeLeeImage, 
    title: "CoffeeLee", 
    description: t('discovery.descCoffeeLee'), 
    category: "Street Vendors",
    filterAction: { venueCategory: ['Street Vendor'], cuisineTags: ['Coffee'] }
  },
  { 
    id: 14, 
    image: CryptLeeImage, 
    title: "CryptLee", 
    description: t('discovery.descCryptLee'), 
    category: "Crypto Payment",
    filterAction: { paymentCrypto: true }
  },
  { 
    id: 15, 
    image: DaiLeeImage, 
    title: "DaiLee", 
    description: t('discovery.descDaiLee'), 
    category: "Daily Shopping",
    filterAction: { venueCategory: ['Shop'] }
  },
  { 
    id: 16, 
    image: DateLeeImage, 
    title: "DateLee", 
    description: t('discovery.descDateLee'), 
    category: "Date Shops",
    filterAction: { venueCategory: ['Street Vendor'], cuisineTags: ['Dates'] }
  },
  { 
    id: 17, 
    image: FaciaLeeImage, 
    title: "FaciaLee", 
    description: t('discovery.descFaciaLee'), 
    category: "Beauty & Spa",
    filterAction: { venueCategory: ['Salon'] }
  },
  { 
    id: 18, 
    image: FalafLeeImage, 
    title: "FalafLee", 
    description: t('discovery.descFalafLee'), 
    category: "Middle Eastern",
    filterAction: { cuisineTags: ['Falafel', 'Middle Eastern'] }
  },
  { 
    id: 19, 
    image: FastLeeImage, 
    title: "FastLee", 
    description: t('discovery.descFastLee'), 
    category: "Fast Food",
    filterAction: { venueCategory: ['Fast Food'] }
  },
  { 
    id: 20, 
    image: FestivaLeeImage, 
    title: "FestivaLee", 
    description: t('discovery.descFestivaLee'), 
    category: "Events",
    filterAction: { venueCategory: ['Events'] }
  },
  { 
    id: 21, 
    image: FineLeeImage, 
    title: "FineLee", 
    description: t('discovery.descFineLee'), 
    category: "Fine Dining",
    filterAction: { venueCategory: ['Restaurant'], venueSubType: ['Fine Dining'] }
  },
  { 
    id: 22, 
    image: FitLeeImage, 
    title: "FitLee", 
    description: t('discovery.descFitLee'), 
    category: "Fitness",
    filterAction: { venueCategory: ['Gym'] }
  },
  { 
    id: 23, 
    image: FoodCOurtLeeImage, 
    title: "FoodCOurtLee", 
    description: t('discovery.descFoodCOurtLee'), 
    category: "Food Court",
    filterAction: { venueCategory: ['Food Court'] }
  },
  { 
    id: 28, 
    image: GolfLeeImage, 
    title: "GolfLee", 
    description: t('discovery.descGolfLee'), 
    category: "Sports",
    filterAction: { venueCategory: ['Golf'] }
  },
  { 
    id: 29, 
    image: GymLeeImage, 
    title: "GymLee", 
    description: t('discovery.descGymLee'), 
    category: "Fitness",
    filterAction: { venueCategory: ['Gym'] }
  },
  { 
    id: 30, 
    image: HamamLeeImage, 
    title: "HamamLee", 
    description: t('discovery.descHamamLee'), 
    category: "Spa & Wellness",
    filterAction: { venueCategory: ['Spa'] }
  },
  { 
    id: 31, 
    image: HappeeLeeImage, 
    title: "HappeeLee", 
    description: t('discovery.descHappeeLee'), 
    category: "Entertainment",
    filterAction: { venueCategory: ['Bar', 'Restaurant'] }
  },
  { 
    id: 32, 
    image: HealtheeLeeImage, 
    title: "HealtheeLee", 
    description: t('discovery.descHealtheeLee'), 
    category: "Healthy Food",
    filterAction: { healthyFoodLevels: ['High'] }
  },
  { 
    id: 33, 
    image: HennaLeeImage, 
    title: "HennaLee", 
    description: t('discovery.descHennaLee'), 
    category: "Beauty & Art",
    filterAction: { venueCategory: ['Salon'] }
  },
  { 
    id: 34, 
    image: IceLeeImage, 
    title: "IceLee", 
    description: t('discovery.descIceLee'), 
    category: "Desserts",
    filterAction: { cuisineTags: ['Ice Cream', 'Desserts'] }
  },
  { 
    id: 35, 
    image: IceLeeStreetImage, 
    title: "IceLee Street", 
    description: t('discovery.descIceLeeStreet'), 
    category: "Street Vendors",
    filterAction: { venueCategory: ['Street Vendor'], cuisineTags: ['Ice Cream'] }
  },
  { 
    id: 36, 
    image: KebabLeeImage, 
    title: "KebabLee", 
    description: t('discovery.descKebabLee'), 
    category: "Middle Eastern",
    filterAction: { cuisineTags: ['Kebab', 'Middle Eastern'] }
  },
  { 
    id: 37, 
    image: KunafeeLeeImage, 
    title: "KunafeeLee", 
    description: t('discovery.descKunafeeLee'), 
    category: "Desserts",
    filterAction: { cuisineTags: ['Kunafa', 'Desserts'] }
  },
  { 
    id: 38, 
    image: LaundreeLeeImage, 
    title: "LaundreeLee", 
    description: t('discovery.descLaundreeLee'), 
    category: "Services",
    filterAction: { venueCategory: ['Laundry'] }
  },
  { 
    id: 39, 
    image: LeeFiImage, 
    title: "LeeFi", 
    description: t('discovery.descLeeFi'), 
    category: "WiFi",
    filterAction: { hasWifiGold: true }
  },
  { 
    id: 40, 
    image: LeesPressoImage, 
    title: "LeesPresso", 
    description: t('discovery.descLeesPresso'), 
    category: "Coffee",
    filterAction: { venueCategory: ['Cafe'], cuisineTags: ['Espresso', 'Coffee'] }
  },
  { 
    id: 41, 
    image: LuquaineeLeeImage, 
    title: "LuquaineeLee", 
    description: t('discovery.descLuquaineeLee'), 
    category: "Desserts",
    filterAction: { cuisineTags: ['Luqaimat', 'Arabic', 'Desserts'] }
  },
  { 
    id: 42, 
    image: ManaqeeLeeImage, 
    title: "ManaqeeLee", 
    description: t('discovery.descManaqeeLee'), 
    category: "Middle Eastern",
    filterAction: { cuisineTags: ['Manakish', 'Middle Eastern'] }
  },
  { 
    id: 43, 
    image: PadLeeImage, 
    title: "PadLee", 
    description: t('discovery.descPadLee'), 
    category: "Asian Cuisine",
    filterAction: { cuisineTags: ['Thai', 'Asian'] }
  },
  { 
    id: 44, 
    image: PamperLeeImage, 
    title: "PamperLee", 
    description: t('discovery.descPamperLee'), 
    category: "Spa & Wellness",
    filterAction: { venueCategory: ['Spa'] }
  },
  { 
    id: 45, 
    image: ParteeLeeImage, 
    title: "ParteeLee", 
    description: t('discovery.descParteeLee'), 
    category: "Nightlife",
    filterAction: { venueCategory: ['Bar', 'Club'] }
  },
  { 
    id: 46, 
    image: PeeLateesImage, 
    title: "PeeLatees", 
    description: t('discovery.descPeeLatees'), 
    category: "Late Night",
    filterAction: { openLate: true }
  },
  { 
    id: 47, 
    image: PlugLeeImage, 
    title: "PlugLee", 
    description: t('discovery.descPlugLee'), 
    category: "Charging",
    filterAction: { hasCharging: true }
  },
  { 
    id: 48, 
    image: QuietLeeImage, 
    title: "QuietLee", 
    description: t('discovery.descQuietLee'), 
    category: "Coworking",
    filterAction: { venueCategory: ['Coworking'], isQuiet: true }
  },
  { 
    id: 49, 
    image: SeeFoodLeeImage, 
    title: "SeeFoodLee", 
    description: t('discovery.descSeeFoodLee'), 
    category: "Seafood",
    filterAction: { cuisineTags: ['Seafood'] }
  },
  { 
    id: 50, 
    image: ShishaLeeImage, 
    title: "ShishaLee", 
    description: t('discovery.descShishaLee'), 
    category: "Shisha",
    filterAction: { venueCategory: ['Shisha Lounge'] }
  },
  { 
    id: 51, 
    image: ShopLeeImage, 
    title: "ShopLee", 
    description: t('discovery.descShopLee'), 
    category: "Shopping",
    filterAction: { venueCategory: ['Shop'] }
  },
  { 
    id: 52, 
    image: SinghLeeImage, 
    title: "SinghLee", 
    description: t('discovery.descSinghLee'), 
    category: "Entertainment",
    filterAction: { venueCategory: ['Entertainment'] }
  },
  { 
    id: 53, 
    image: SugarLeeImage, 
    title: "SugarLee", 
    description: t('discovery.descSugarLee'), 
    category: "Desserts",
    filterAction: { cuisineTags: ['Desserts', 'Sweets'] }
  },
  { 
    id: 54, 
    image: SunsetLeeImage, 
    title: "SunsetLee", 
    description: t('discovery.descSunsetLee'), 
    category: "Rooftop",
    filterAction: { venueSubType: ['Rooftop'] }
  },
  { 
    id: 55, 
    image: SusheeLeeImage, 
    title: "SusheeLee", 
    description: t('discovery.descSusheeLee'), 
    category: "Japanese Cuisine",
    filterAction: { cuisineTags: ['Sushi', 'Japanese'] }
  },
  { 
    id: 56, 
    image: SweatLeeImage, 
    title: "SweatLee", 
    description: t('discovery.descSweatLee'), 
    category: "Spa & Wellness",
    filterAction: { venueCategory: ['Spa'] }
  },
  { 
    id: 57, 
    image: TeeLeeImage, 
    title: "TeeLee", 
    description: t('discovery.descTeeLee'), 
    category: "Tea",
    filterAction: { venueCategory: ['Cafe'], cuisineTags: ['Tea'] }
  },
  { 
    id: 58, 
    image: TeeVeeLeeImage, 
    title: "TeeVeeLee", 
    description: t('discovery.descTeeVeeLee'), 
    category: "Sports Bar",
    filterAction: { venueCategory: ['Bar'], venueSubType: ['Sports Bar'] }
  },
  { 
    id: 59, 
    image: VegeeLeeImage, 
    title: "VegeeLee", 
    description: t('discovery.descVegeeLee'), 
    category: "Vegetarian",
    filterAction: { dietaryTags: ['Vegetarian', 'Vegan'], vegOnly: true }
  },
  { 
    id: 60, 
    image: YogeeImage, 
    title: "Yogee", 
    description: t('discovery.descYogee'), 
    category: "Yoga & Wellness",
    filterAction: { venueCategory: ['Yoga Studio'] }
  }
];

const DiscoveryPage = ({ onCardClick, onClose }) => {
  const { t } = useTranslation();
  const discoveryData = useMemo(() => getDiscoveryData(t), [t]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const loadingRef = useRef();

  const loadMoreItems = useCallback(() => {
    if (loading) return;
    setLoading(true);
    setTimeout(() => {
      const startIndex = (page - 1) * 6;
      const newItems = [];
      for (let i = 0; i < 6; i++) {
        const dataIndex = (startIndex + i) % discoveryData.length;
        newItems.push({
          ...discoveryData[dataIndex],
          id: `${discoveryData[dataIndex].id}-${page}-${i}`
        });
      }
      if (newItems.length > 0) {
        setItems(prev => [...prev, ...newItems]);
        setPage(prev => prev + 1);
      }
      setLoading(false);
    }, 400);
  }, [page, loading, discoveryData]);

  useEffect(() => {
    loadMoreItems();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && !loading) {
          loadMoreItems();
        }
      },
      { threshold: 0.1 }
    );
    if (loadingRef.current) {
      observer.observe(loadingRef.current);
    }
    return () => {
      if (loadingRef.current) {
        observer.unobserve(loadingRef.current);
      }
    };
  }, [loadMoreItems, loading]);

  const handleCardClick = (item) => {
    if (onCardClick) {
      onCardClick(item);
    }
  };

  return (
    <div style={{
      borderRadius: '20px',
      padding: '20px 0',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      minHeight: '100%'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '20px',
        padding: '0 16px'
      }}>
        <button
          onClick={onClose}
          style={{
            background: 'linear-gradient(135deg, #f5933d 0%, #184A99 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            padding: '8px 16px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            boxShadow: '0 2px 8px rgba(217, 100, 31, 0.3)'
          }}
        >
          ← {t('common.back')}
        </button>
      </div>

      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        style={{
          textAlign: 'center',
          marginBottom: '20px',
          padding: '0 16px'
        }}
      >
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#111827',
          margin: '0 0 8px 0'
        }}>
          {t('discovery.title', { region: REGION_CONFIG.displayName })}
        </h2>
        <p style={{
          fontSize: '14px',
          color: '#6b7280',
          margin: 0,
          fontWeight: '500'
        }}>
          {t('discovery.subtitle')}
        </p>
      </motion.div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
        marginBottom: '32px',
        padding: '0 16px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <AnimatePresence>
          {items.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
              onClick={() => handleCardClick(item)}
              style={{
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <div style={{
                width: '100%',
                height: '200px',
                overflow: 'hidden',
                borderRadius: '24px',
                marginBottom: '-10px',
                position: 'relative'
              }}>
                <img
                  src={item.image}
                  alt={item.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    transition: 'transform 0.3s ease',
                    display: 'block'
                  }}
                  onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                />
              </div>
              <div style={{
                background: 'linear-gradient(135deg, #f5933d 0%, #184A99 100%)',
                borderRadius: '16px',
                padding: '10px 16px',
                width: '85%',
                maxWidth: '320px',
                textAlign: 'center',
                zIndex: 10,
                boxShadow: `
                  inset 0 0 0.5px 1px rgba(255, 255, 255, 0.15),
                  0 0 0 1px rgba(255, 255, 255, 0.1),
                  0 2px 4px rgba(255, 255, 255, 0.3),
                  0 4px 8px rgba(255, 255, 255, 0.25),
                  0 8px 16px rgba(255, 255, 255, 0.2),
                  0 0 20px rgba(255, 255, 255, 0.15)
                `
              }}>
                <h3 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#ffffff',
                  margin: '0 0 4px 0',
                  lineHeight: '1.2'
                }}>
                  {item.title}
                </h3>
                <p style={{
                  fontSize: '12px',
                  color: '#f0f0f0',
                  margin: 0,
                  lineHeight: '1.4'
                }}>
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>

      <div ref={loadingRef} style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '24px 0'
      }}>
        {loading && (
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
            style={{
              width: '24px',
              height: '24px',
              border: '3px solid #e5e7eb',
              borderTop: '3px solid #ea580c',
              borderRadius: '50%'
            }}
          />
        )}
      </div>
    </div>
  );
};

export default DiscoveryPage;